import React from 'react';
import {Route, Redirect} from "react-router-dom";
import URLS from "../../config/navigation";

const PreProtectedRoute = (props) => {

    const {path, component: Component, ...rest} = props;
    const tag = localStorage.getItem("onBoarding");

    return (
        <Route
            {...rest}
            render={() => ((tag === "true" && tag)
                ? (<Component {...props} />)
                : (
                    <Redirect to={{
                        pathname: URLS.PROFILE.DATA,
                        state: { from: props.location },
                    }}
                    />
                ))}
        />
    )
};

export default PreProtectedRoute;
